<script setup>
import { storeToRefs } from "pinia";
import Layout from "./components/Layout.vue";
import Loading from "@/components/Loading.vue";
import Toaster from "@/components/Toaster.vue";
import LoginView from "@/views/auth/LoginView.vue";
import { useAuthStore } from "@/stores/auth.js";
import ToasterNotification from "./components/ToasterNotification.vue";
import { useNotificationSocket } from "./composables/useNotificationSocket";
import { computed, watch } from "vue";

const auth = useAuthStore();

// Akses .value karena user adalah RefImpl
const userId = computed(() => {
  const id = auth.user?.user_information?.id; // tambah ?. setelah auth.user
  return id ? String(id) : null;
});

// Panggil useNotificationSocket di dalam watch, bukan di luar
const { initSocket } = useNotificationSocket();

watch(
  userId,
  (newId) => {
    if (newId) {
      initSocket(newId);
    }
  },
  { immediate: true },
);

// const { isAdmin } = storeToRefs(auth)
const { isAuthenticated } = storeToRefs(auth);
</script>

<template>
  <div>
    <Loading />
    <Layout v-if="isAuthenticated" />
    <LoginView v-else />
    <Toaster />
    <ToasterNotification />
  </div>
</template>

<style scoped>
/* App-level resets or variables can live here if needed */
</style>
